// extracted by mini-css-extract-plugin
module.exports = {"modal":"ActionConfirmModal_modal__2u-X-"};